import { queryOptions } from '@tanstack/react-query';
import { getComplaintSummaryFunction } from './getComplaintSummaryQueryFunction';

export const getComplaintSummaryQueryOptions = () => {
  return queryOptions({
    queryKey: ['ComplaintSurvey'],
    queryFn: () => getComplaintSummaryFunction(),
  });
};
